export default "__VITE_ASSET__BnvbRh_O__"